import React, { useEffect, useState } from 'react';
import EasyAreaChart from '../ReChart/EasyAreaChart';
import EasyBarChart from '../ReChart/EasyBarChart';
import EasyLineChart from '../ReChart/EasyLineChart';
import './DashBoard.css'


const DashBoard = () => {
 
    return (
        <div className='dashboard'>
        <EasyLineChart></EasyLineChart>
        <EasyBarChart></EasyBarChart>
        <EasyAreaChart></EasyAreaChart>
        </div>
    );
};

export default DashBoard;